export default {
  haulers: 'Spediteure',
  setup: 'Konfiguration',
  driverExperience: 'Fahrererfahrung',
  users: 'Benutzer',
};
